// @ts-nocheck
import {useListView} from './core/ListViewProvider'
import {UsersListHeader} from './components/header/UsersListHeader'
import {UsersTable} from './table/UsersTable'
import {KTCard} from '../../../../_metronic/helpers'
import {useState, useCallback} from 'react'

const UsersList = () => {
  const [userSearch, setUserSearch] = useState('')
  const [genderFilter, setGenderFilter] = useState('')
  const [sDate, setSDate] = useState<any>('')
  const [eDate, setEDate] = useState<any>('')
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState<boolean>(false)
  const [applyFilter, setApplyFilter] = useState<boolean>(false)
  const [bookingsData, setBookingsData] = useState<any[]>([])

  const handleDataChange = useCallback((data: any[]) => {
    console.log('🔄 Bookings data changed in parent:', data)
    setBookingsData(data)
  }, [])

  return (
    <>
      <KTCard>
        {/* Search | Filter | Export Button Begins */}
        <UsersListHeader
          genderFilter={genderFilter}
          setGenderFilter={setGenderFilter}
          userSearch={userSearch}
          setUserSearch={setUserSearch}
          sDate={sDate}
          setSDate={setSDate}
          eDate={eDate}
          setEDate={setEDate}
          page={page}
          setPage={setPage}
          loading={loading}
          setLoading={setLoading}
          applyFilter={applyFilter}
          setApplyFilter={setApplyFilter}
          bookingsData={bookingsData}
        />
        {/* Search | Filter | Export Button Ends */}
        <UsersTable
          genderFilter={genderFilter}
          setGenderFilter={setGenderFilter}
          userSearch={userSearch}
          setUserSearch={setUserSearch}
          sDate={sDate}
          setSDate={setSDate}
          eDate={eDate}
          setEDate={setEDate}
          page={page}
          setPage={setPage}
          loading={loading}
          setLoading={setLoading}
          applyFilter={applyFilter}
          setApplyFilter={setApplyFilter}
          onDataChange={handleDataChange}
        />
      </KTCard>
    </>
  )
}

const UsersListWrapper = () => <UsersList />

export {UsersListWrapper}
